import axios from 'axios';

const settingsPath = (agentId) => `/agents/${encodeURIComponent(agentId)}/business-action-success-settings`;
const actionPath = (agentId, actionKey) => `${settingsPath(agentId)}/${encodeURIComponent(actionKey)}`;

export async function getBusinessActionSuccessSettings(agentId) {
  const { data } = await axios.get(settingsPath(agentId));
  return data;
}

export async function saveBusinessActionSuccessSetting(agentId, actionKey, setting) {
  const { data } = await axios.put(actionPath(agentId, actionKey), {
    displayReferenceNumber: setting.displayReferenceNumber,
    additionalSuccessMessageHtml: setting.additionalSuccessMessageHtml,
  });
  return data;
}

export async function resetBusinessActionSuccessSetting(agentId, actionKey) {
  const { data } = await axios.delete(actionPath(agentId, actionKey));
  return data;
}
